import useEligibilityOptions from './useEligibilityOptions';
export type { EligibilityOption } from './useEligibilityOptions';

export default useEligibilityOptions;
